import type { RefObject } from "react";

export function findNearestScroller(
  startRef: HTMLElement | null | RefObject<HTMLElement>
) {
  let currentElement =
    startRef instanceof HTMLElement
      ? startRef
      : startRef?.current?.parentElement;

  while (currentElement) {
    const styles = window.getComputedStyle(currentElement);

    if (
      (["auto", "scroll", "overlay"].includes(styles.overflow) ||
        ["auto", "scroll", "overlay"].includes(styles.overflowY)) &&
      currentElement !== document.body
    ) {
      return currentElement;
    }

    currentElement = currentElement.parentElement;
  }
}
